module.exports = __webpack_public_path__ + "img/symbol_3.36956778.png";